import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import messages, { FormattedMessage, withValues } from 'shared/messages/messages';
import {
  CardElement
} from '@stripe/react-stripe-js';

import {
  renderPurchaseDescriptionStatic
} from 'shared/services/PriceService';

import {
  purchase,
  setPurchaseLoading,
  addPurchase
} from 'shared/actions/cartActions';

import { getSelectedCalculations } from 'shared/selectors/cartSelectors';


const styles = theme => ({
  cardElement: {
    display: 'inline-block',
    width: '100%',
    height: '3.28rem',
    padding: '1rem',
    marginBottom: '0',
    border: '1px solid #aaa',
    borderRadius: '5px',
    error: null,
    background: 'white !important'
  },
  error: {
    display: 'inline-block',
    float: 'left',
    width: '100%',
    textAlign: 'left',
    color: 'red',
    marginBottom: '0.2rem'
  }
});

class MobileCartPaymentForm extends React.Component {
  constructor(props) {
    super(props);

    this.options = {
      hidePostalCode: true,
      style: {
        base: {
          fontSize: '1.1rem',
        },
        invalid: {
          color: 'red'
        }
      }
    }

    this.submitting = false;

    this.state = {
      error: null
    }
  }

  componentWillUpdate() {
    const button = this.props.button.current;
    if (button) {
      this.buttonText = this.buttonText || button.innerText;
      button.onclick = this.submit.bind(this);
    }
  }

  onChange(event) {
    if (event.error) {
      this.setError(event.error.message);
    } else {
      this.clearError();
    }
  }

  getPurchaseDescription() {
    const {
      selectedMomentIds,
      locale,
      messages: compiledMessages
    } = this.props;

    let digitals = selectedMomentIds.length;
    let unlockAll = false;

    if (digitals) {
      return renderPurchaseDescriptionStatic(locale, compiledMessages, digitals, 0, unlockAll, false);
    }
    return '';
  }

  async submit(event) {
    if (this.submitting) {
      return;
    }
    this.submitting = true;

    const { stripe, elements, selectedMomentIds, accountId, storyId } = this.props;
    if (!stripe || !elements) {
      return;
    }

    event.preventDefault();

    const email = this.props.email.current;
    const button = this.props.button.current;

    if (!email.dummy) {
      if (!email.value || !email.value.match(/@/)) {
        email.style.borderColor = 'red';
        email.onchange = function () {
          this.style.borderColor = '#aaa';
        }
        return;
      } else {
        email.style.borderColor = '#aaa';
      }
    }

    this.showPurchasing();
    this.clearError();

    try {
      const { stripe, elements, freeMode, calculations } = this.props;

      let paymentMethodId = null;
      if (!freeMode) {
        const cardElement = elements.getElement(CardElement);
        const { paymentMethod, error } = await stripe.createPaymentMethod({
          type: 'card',
          card: cardElement
        });

        if (error) {
          this.clearPurchasing(button);
          this.setError(error);
          this.submitting = false;
          return;
        }

        paymentMethodId = paymentMethod.id;
      }

      let description = this.getPurchaseDescription();

      let params = {
        payment_method_id: paymentMethodId,
        moment_ids: selectedMomentIds,
        email: email.value,
        account_id: accountId,
        story_id: storyId,
        coupon_code: calculations.discount_coupon_code,
        description
      }

      let purchase = null;

      this.props.purchase(params).then(async (result) => {
        purchase = result;

        if (purchase.requires_action) {
          let { paymentIntent, error } = await stripe.handleCardAction(purchase.payment_intent_client_secret);

          if (error) {
            this.clearPurchasing(button);
            this.setError(error);
            return;
          }

          params.payment_method_id = null;
          params.payment_intent_id = paymentIntent.id;

          this.props.purchase(params).then((result) => {
            purchase = result;
          })
        }

        this.clearPurchasing(button);
        this.props.callback(purchase, this.props.selectedMomentIds);
      }).catch((error) => {
        this.clearPurchasing(button);
        this.submitting = false;
        this.setError(error);
      })

    } catch (err) {
      this.clearPurchasing(button);
      this.submitting = false;

      if (err.error) {
        this.setError(err);
        this.setError(<FormattedMessage {...messages.cart_sorry_charge_problem} />);
      }
    }
  }

  showPurchasing() {
    this.props.setPurchaseLoading(true);
  }

  clearPurchasing(button) {
    this.props.setPurchaseLoading(false);
  }

  clearError() {
    this.setState({ error: null });
  }

  setError(err) {
    console.log(err);

    if (typeof err === 'string') {
      this.setState({ error: err });
    } else if (err.error){
      this.setState({ error: err.error });
    } else if (err.message) {
      this.setState({ error: err.message });
    }
  }

  render() {
    const { classes, errorStyle, freeMode, selectionItems } = this.props;

    let error = null;
    if (this.state.error) {
      error = (
        <span className={classes.error} style={errorStyle}>{this.state.error}</span>
      );
    }

    let form;
    if (freeMode) {
      let msgStyle = {
        marginTop: '1.75rem',
        fontWeight: 600
      }

      let msg = <FormattedMessage {...withValues(messages.cart_image_free_of_charge, { imageDesc: selectionItems.length === 1 ? 'image' : 'images' })} />

      form = <p style={msgStyle}>{msg}</p>;

    } else {
      form = (
        <div className={classes.cardElement}>
          <CardElement options={this.options} />
        </div>
      );
    }

    return (
      <div>
        {form}
        {error}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  selectionItems: state.selectionReducer.selection.items,
  selectedMomentIds: state.cartReducer.selectedMomentIds,
  calculations: getSelectedCalculations(state),
  locale: state.messagesReducer.locale,
  messages: state.messagesReducer.messages
});

export default connect(mapStateToProps, { addPurchase, purchase, setPurchaseLoading })(withStyles(styles, { withTheme: true })(MobileCartPaymentForm));
